<style scoped>
    .upload_input{
        color: inherit;
        background-color: inherit;
        display: none;
    }
    .quill_box{
        width: 50%
    }
    .ql-container.ql-snow{
        height: 500px
    }
    .ql-snow .ql-tooltip{
        left: 20px!important
    }
</style>
<template>
    <Row class="content quill_box">
        <Spin v-show="uploadContent" fix>{{uploadContent}}...</Spin>
        <input class="upload_input" type="file" ref="videoElem" id="videoElem" accept="video/*" @change="changeVideo($event)">
        <input class="upload_input" type="file" ref="imageElem" id="imageElem" accept="image/*" @change="changeImage($event)">
        <quill-editor ref="myTextEditor" :content="content" :options="editorOption" @change="onEditorChange($event)" class="quill">
            <div id="toolbar">
                <button class="ql-snow ql-bold"></button>
            </div>
        </quill-editor>
        <br>
        <Button size="large" type="primary" style="margin-right: 20px;" @click="save">保存</Button>
        <Button size="large" @click="back">返回</Button>
    </Row>
</template>
<script>
import { quillEditor } from 'vue-quill-editor'
import http from "../../libs/http.js"
import "../../assets/js/aliyun-oss.min.js"
import "../../assets/js/aliyun-upload.min.js"
const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
    ["blockquote", "code-block"], // 引用  代码块
    [{ header: 1 }, { header: 2 }], // 1、2 级标题
    [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
    [{ script: "sub" }, { script: "super" }], // 上标/下标
    [{ indent: "-1" }, { indent: "+1" }], // 缩进
    // [{'direction': 'rtl'}],                         // 文本方向
    [{ size: ["small", false, "large", "huge"] }], // 字体大小
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
    [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
    [{ font: [] }], // 字体种类
    [{ align: [] }], // 对齐方式
    ["clean"], // 清除文本格式
    ["link", "image", "video"], // 链接、图片、视频
];

export default {
    data() {
        return {
            content: '',
            uploadContent: '',
            editorOption: {
                placeholder: "",
                theme: "snow", // or 'bubble'
                placeholder: "请输入文本内容...",
                modules: {
                    toolbar: {
                        container: toolbarOptions,
                        handlers: {
                            'video': function(value) {
                                if (value) {
                                    var videoElem = document.getElementById('videoElem')
                                    videoElem.dispatchEvent(new MouseEvent('click'))
                                }
                            },
                            'image': function(value) {
                                if (value) {
                                    var imageElem = document.getElementById('imageElem')
                                    imageElem.dispatchEvent(new MouseEvent('click'))
                                }
                            },
                        }
                    }
                }
            },
            uploadVideoAuth: null,
            videoId: null
        }
    },
    methods: {
        save(){
        },
        back(){
            this.$router.go(-1)
        },
        changeVideo(event) {
            let videoFile = event.target.files[0]
            this.title = videoFile.name.substring(0, videoFile.name.lastIndexOf('.'))
            this.getUploadVideoAuth(videoFile, videoFile.name, this.title);
        },
        changeImage(event) {
            let _this = this;
            let imageFile = event.target.files[0]
            _this.uploadContent = '图片上传中, 请稍后'
            var formData = new FormData();
            formData.append('file', imageFile)
            http.form('/file/upload', formData).then(res => {
                if (res) {
                    _this.content = _this.content+'<p><img style="width:100%" src="'+res.url+'"><p>'
                    _this.uploadContent = ''
                }
            })
        },
        getUploadVideoAuth(file, name, title) {
            let _this = this;
            let sendData = {
                fileName: name,
                title: title
            }
            http.post('/aliyun/video/upload/create', sendData).then(res => {
                if (res) {
                    _this.uploadVideoAuth = res
                    let userData;
                    _this.uploader.addFile(file, null, null, null, userData);
                    _this.uploader.startUpload();
                }
            })
        },
        // 自动获取视频信息
        getVideoDataAuto() {
            let _this = this;
            this.videoLoading = true;
            let interval = setInterval(getVideoData, 3000)

            function getVideoData() {
                http.get('/video/get', { videoId: _this.uploadVideoAuth.videoId }).then(res => {
                    if (res.status == 'Normal') {
                        clearInterval(interval)
                        if (res.mp4PlayUrl) {
                            _this.uploadContent = ''
                             _this.content =  _this.content+'<iframe class="ql-video" frameborder="0" allowfullscreen="true" src="'+res.mp4PlayUrl+'"></iframe><p><br></p>'
                        } else {
                            _this.$Message.error('请重新上传');
                        }
                    }
                })
            }
        },
        onEditorChange(editor) {
            this.content = editor.html
        }
    },
    created() {
        let _this = this;
        this.uploader = new AliyunUpload.Vod({
            //分片大小默认1M，不能小于100K
            partSize: 1048576,
            //并行上传分片个数，默认5
            parallel: 5,
            //网络原因失败时，重新上传次数，默认为3
            retryCount: 3,
            //网络原因失败时，重新上传间隔时间，默认为2秒
            retryDuration: 2,
            // 开始上传
            'onUploadstarted': function(uploadInfo) {
                _this.uploadStatus = 'onUploadStarted';
                //上传方式1, 需要根据uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress，如果videoId有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
                _this.uploader.setUploadAuthAndAddress(uploadInfo, _this.uploadVideoAuth.uploadAuth, _this.uploadVideoAuth.uploadAddress, _this.uploadVideoAuth.videoId);
                //上传方式2
                // uploader.setSTSToken(uploadInfo, accessKeyId, accessKeySecret,secretToken);
            },
            // 文件上传成功
            'onUploadSucceed': function() {
                // uploadInfo
                _this.uploadStatus = 'onUploadSucceed';
                _this.uploadContent = '视频上传成功, 转码中'
                _this.getVideoDataAuto()
            },
            // 文件上传失败
            'onUploadFailed': function() {
                _this.uploadStatus = 'onUploadFailed';
            },
            // 文件上传进度，单位：字节
            'onUploadProgress': function(uploadInfo, totalSize, loadedPercent) {
                _this.uploadStatus = 'onUploadProgress';
                _this.uploadContent = '视频上传中, 上传进度'+Math.ceil(loadedPercent * 100)+'';

            },
            // 上传凭证超时
            'onUploadTokenExpired': function() {
                // uploadInfo
                _this.uploadStatus = 'onUploadTokenExpired';
                //上传方式1  实现时，根据uploadInfo.videoId调用刷新视频上传凭证接口重新获取UploadAuth
                _this.uploader.resumeUploadWithAuth(_this.uploadVideoAuth.uploadAuth);
                // 上传方式2 实现时，从新获取STS临时账号用于恢复上传
                // uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expireTime);
            },
            //全部文件上传结束
            'onUploadEnd': function() {
                // uploadInfo
                _this.uploadStatus = 'onUploadEnd';
            }
        });
    },
    destroyed() {
        this.uploader.stopUpload();
    },
}
</script>
